



























































































import { AttachedData } from "@/models/OpportunityAttachmentData";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment-timezone";

@Component
export default class extends Vue {
  $refs!: {
    element: HTMLInputElement;
  };

  @Prop()
  value!: AttachedData[];

  @Prop()
  filelist!: File[];

  @Prop()
  isNotEditable!: boolean;

  @Prop()
  show!: boolean;

  isVisible = this.show;

  dragging = false;
  file!: string;
  showErrorMessage = false;
  message = "";

  onChange(e: Event): void {
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files.length) {
      this.dragging = false;
      return;
    }
    this.createFile(files);
    (document.getElementById("file") as HTMLInputElement).value = "";
  }

  convertToEST(date: string): string {
    if (date != null) {
      return (
        moment.tz(date, "America/New_York").format("MM/DD/YYYY, h:mm:ss A") +
        " EST"
      );
    }
    return "Click Save to attach the document";
  }

  createFile(files: FileList): void {
    if (this.value.length + files.length > 50) {
      this.showErrorMessage = true;
      this.message = "Maximum file upload limit is 50.";
      this.dragging = false;
      return;
    }
    for (const file of files) {
      if (!file.type.match(".pdf")) {
        this.showErrorMessage = true;
        this.message = "Please select valid PDF file.";
        this.dragging = false;
        return;
      }
      if (file.size > 5242880) {
        this.showErrorMessage = true;
        this.message = "File size limit is 5 MB.";
        this.dragging = false;
        return;
      }
      if (this.value.some((x) => x.documentName === file.name)) {
        const blob = file.slice(0, file.size, file.type);
        const newFile = new File(
          [blob],
          this.checkNameOfTheFile(file.name, 0),
          {
            type: file.type,
          }
        );
        this.filelist.push(newFile);
      } else {
        this.filelist.push(file);
      }
    }
    this.dragging = false;
  }

  removeFile(index: number): void {
    this.file = this.filelist[index].name;
    this.filelist.splice(index, 1);
  }

  downloadFile(index: number): void {
    this.file = this.filelist[index].name;
    this.$emit("download", this.file);
  }

  checkNameOfTheFile(fileName: string, index: number): string {
    let checkName = fileName;
    let ext = "";
    if (index) {
      if (checkName.indexOf(".") > -1) {
        const tokens = checkName.split(".");
        ext = "." + tokens.pop();
        checkName = tokens.join(".");
      }
      checkName = `${checkName} (${index})${ext}`;
    }
    const nameExists =
      this.value.filter((f) => f.documentName === checkName).length > 0;
    return nameExists
      ? this.checkNameOfTheFile(fileName, index + 1)
      : checkName;
  }

  @Watch("filelist", { deep: true })
  onFilesChanged(newValue: File[]): void {
    if (this.value.length < newValue.length) {
      this.$emit("changed", newValue);
    } else if (this.value.length > newValue.length) {
      this.$emit("deleted", this.file);
    }
  }
}
